import ReactGA from 'react-ga4';

const sendAnalyticsEvent = (eventName, params = {}) => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
        // GA tag not initialized, likely because of cookie preferences
        return null;
    }
    ReactGA.event(eventName, params);
    return null;
};

export default sendAnalyticsEvent;
